import { withAuthenticationRequired } from '@auth0/auth0-react';

function PrivateRoute({ children }: { children?: any }) {
	return children;
}

export default withAuthenticationRequired(PrivateRoute, {
	returnTo: `${window.location.pathname}${window.location.search}${window.location.hash}`,
});
